const headers = {
  name: "Create Credit Note",
  navigate: {
    path: [
      {
        name: "Credit Notes",
        path: "/app/sales/credit-notes",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;